import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import SectionTitle from '../Presentation/SectionTitle';
import PackageProgress from '../Presentation/PackageProgress';
import Loader from '../Presentation/Loader';

class CurrentPackage extends React.Component {

    render() {
        const {packagesPending, userMeditationsPending, pack, nextMedNumber, startNew} = this.props;
        const loading = packagesPending || userMeditationsPending;

        if (pack === false) {
            return null;
        }
        else {
            return <section className="section-current-set">
                <Loader show={loading}/>
                <div className={"current-set" + (loading ? " loading" : "")}>
                    <SectionTitle>{pack.title}</SectionTitle>

                    <Link className="play-btn" to={`/meditate/${pack.id}`}>{startNew ? "Започни" : "Продължи"}</Link>
                    <Link className="play-btn-mobile" to={`/meditate/${pack.id}`}><img src="/img/play-btn.svg"
                                                                                       alt="play-btn"/></Link>

                    <PackageProgress total={pack.meditationsCount} current={nextMedNumber}/>
                </div>
            </section>
        }
    }
}

const uPackIsCompleted = (uPack) => {
    if (uPack) {

        //TODO
        const completedMeditationsCount = uPack.package.meditations.filter(m => m.completed).length;

        if (completedMeditationsCount === uPack.package.meditationsCount) {
            return true;
        }
    }

    return false;
};

const mapStateToProps = (state) => {
    const {packagesPending, userMeditationsPending} = state.packages;
    let uMeds = state.packages.userMeditations.slice();
    let uPacks = state.packages.userPackages.slice();
    let pack = state.packages.blankPackage;
    let startNew = true;
    let nextMedNumber = 1;
    let packFound = false;

    uMeds.sort((a, b) => {
        return new Date(a.createdAt) > new Date(b.createdAt);
    });

    for (let i = 0; i < uMeds.length; i++) {
        let uPack = uPacks.find(p => p.package.id === uMeds[i].packageId);

        if (uPack && !uPackIsCompleted(uPack)) {
            startNew = false;
            packFound = true;
            pack = uPack.package;
            let nextMed = pack.meditations.find(m => !m.completed);
            if (nextMed) {
                nextMedNumber = nextMed.position;
            }
        }
    }

    if (!packFound) {
        uPacks.sort( (p1, p2) => {
            return p2.package.featured;
        });

        for (let i =0; i < uPacks.length; i++) {
            if (!uPackIsCompleted(uPacks[i]) && uPacks[i].package) {
                pack = uPacks[i].package;
                packFound = true;
                break;
            }
        }
    }

    if (!packFound && !packagesPending && !userMeditationsPending) {
        pack = false;
    }

    return {
        pack,
        nextMedNumber,
        startNew,
        packagesPending,
        userMeditationsPending
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentPackage);




// WEBPACK FOOTER //
// ./src/components/Containers/CurrentPackage.js